/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type CreateUserRows = {
  label: string;
  id: vp.CreateUserId;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'text' | 'select';
  placeholder: string;
  getSelectOptions: () => { [key: string]: string };
};

const useBuildCreateUserRows = (): CreateUserRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.Create' });

  return [
    {
      label: t('emailAddressLabel'),
      id: vp.CreateUserId.EmailAddress,
      preset: 'email',
      type: 'text',
      placeholder: '',
      getSelectOptions: () => ({}),
    },
    {
      label: t('roleLabel'),
      id: vp.CreateUserId.Role,
      preset: 'text',
      type: 'select',
      placeholder: '',
      getSelectOptions: () => vp.PARTNER_USER_ROLE_OPTIONS,
    },
  ];
};
export default useBuildCreateUserRows;
